import React from 'react';
import { createRoot } from 'react-dom/client';
import { clientErrors } from '@cwos/api-client';
import '@cwos/design-tokens/css/tokens.css';
import './app.css';
import { App } from './App.js';
import { ErrorBoundary, GlobalErrorNotice } from './lib/ErrorBoundary.js';
import { installClientErrorReporting, installGlobalErrorHandlers } from './lib/errorReporting.js';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing from index.html');

// Installed before the first render, so a failure during mount is caught too.
installGlobalErrorHandlers(window);

// ...and reported. Until this call existed, `setClientErrorSink` had no
// production caller anywhere: every client-side crash was recorded in the user's
// own tab, shown to them, and then lost. It now goes to Phibian's own API —
// which means it inherits the session, lands in Cloud Logging with a severity
// the API's pino formatter maps for it, and is alertable.
//
// The MESSAGE is not part of what is sent (ADR 0011); see
// lib/errorReporting.ts and packages/api-client/src/clientErrors.ts.
// `import.meta.url` is the hashed bundle URL, which is the release the frames
// belong to — no build argument to keep in step.
installClientErrorReporting({
  moduleUrl: import.meta.url,
  transmit: (report) => clientErrors.report(report),
});

// The boundary wraps EVERYTHING, including the providers. A throw inside auth,
// the query client or the router is exactly the case where the old behaviour
// was a blank page with nothing on it to press.
createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <GlobalErrorNotice />
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
